import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import lamboDiablo from "@/assets/lambo-diablo.jpg";

const CTA = () => {
  return (
    <section className="relative py-32">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={lamboDiablo}
          alt="Lamborghini Diablo at Hyper Haus — request a consultation for PPF, ceramic coating, tint, or detailing"
          loading="lazy"
          width={1440}
          height={1079}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-background/85" />
      </div>

      <div className="container relative">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-2xl mx-auto"
        >
          <h2 className="section-heading mb-6">
            Ready to Protect<br />Your Investment?
          </h2>
          <p className="text-lg text-muted-foreground mb-8">
            Every vehicle receives our best custom service. Contact us for a personalized consultation and pricing.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="tel:3109169046" className="btn-hero-primary">
              <Phone className="w-4 h-4" />
              (310) 916-9046
            </a>
            <Link to="/contact" className="btn-hero-outline">
              Request Consultation
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>

          <p className="text-sm text-muted-foreground mt-8">
            Fastest response: Call or text us directly
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default CTA;
